const color = color => {
  if (color) {
    return `hsl(${color.hsv.h}, ${color.hsv.s}%, ${color.hsv.v - 20}%)`;
  }
  return `#000`;
};

export { color };
